import { IAPIRoutes } from "../../../../config";

// ─── API types ────────────────────────────────────────────────────────────────

export interface IColumnPreferencesApiResponse {
  view_key: string;
  selected_columns: string[];
  updated_at: string;
}

interface IColumnPreferencesPutRequest {
  view_key: string;
  selected_columns: string[];
}

// ─── Repository type ─────────────────────────────────────────────────────────

export type IColumnPreferencesRepository = ReturnType<
  typeof ColumnPreferencesRepositoryFactory
>;

// ─── Factory ─────────────────────────────────────────────────────────────────

export const ColumnPreferencesRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;

  const getColumnPreferences = async (
    viewKey: string
  ): Promise<IColumnPreferencesApiResponse> => {
    // Pass view_key as queryStringParameters (2nd arg) so the provider appends
    // it as a proper query string. Authorization is injected automatically by
    // getDefaultHeaders() inside APIProvider for /patient-centric-app-v2/ routes.
    return await GET(APIRoutes.apiGetColumnPreferences, { view_key: viewKey });
  };

  const putColumnPreferences = async (
    payload: IColumnPreferencesPutRequest
  ): Promise<IColumnPreferencesApiResponse> => {
    // Authorization header is injected automatically by APIProvider.
    return await PUT(APIRoutes.apiPutColumnPreferences, payload);
  };

  return {
    getColumnPreferences,
    putColumnPreferences,
  };
};
